import useLocalStorage from "@dashboard/hooks/useLocalStorage";
import { type DefaultTheme, ThemeProvider as MacawThemeProvider } from "@saleor/macaw-ui-next";
import type * as React from "react";

import { defaultTheme, localStorageKey } from "./consts";
import { applyFlexgPalette } from "./flexgPalette";

// macaw 의 themes 객체를 갈아끼운다. ThemeProvider 가 처음 렌더되기 전에 한 번만 돌면 되고,
// 이 모듈이 그걸 보장하는 가장 이른 지점이다. (2026-09-17 KST 추가)
applyFlexgPalette();

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeTheme] = useLocalStorage<DefaultTheme>(localStorageKey, defaultTheme);

  return <MacawThemeProvider defaultTheme={activeTheme}>{children}</MacawThemeProvider>;
};
